import { apiClient } from "@/shared/api/client"
import type { LoginRequest, WebLoginResponse, SignupRequest, UserResponse } from "@/shared/types/api"

export const authApi = {
  login: async (data: LoginRequest): Promise<WebLoginResponse> => {
    const response = await apiClient.post<{ data: WebLoginResponse }>("/auth/web/login", data)
    return response.data.data
  },

  signup: async (data: SignupRequest): Promise<WebLoginResponse> => {
    const response = await apiClient.post<{ data: WebLoginResponse }>("/auth/web/signup", data)
    return response.data.data
  },

  logout: async (): Promise<void> => {
    await apiClient.post("/auth/web/logout")
  },

  getProfile: async (skipGlobalErrorToast = false): Promise<UserResponse> => {
    const response = await apiClient.get<{ data: UserResponse }>("/user/profile", {
      metadata: { skipGlobalErrorToast }
    })
    return response.data.data
  },
}
